export const SUPPORTED_LOCALES = ["it", "en", "de"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "en";

const STORAGE_KEY = "gb_locale";

export function isValidLocale(val: string): val is Locale {
  return SUPPORTED_LOCALES.includes(val as Locale);
}

// Con i dati dei siti bloccati (Safari «Blocca tutti i cookie», policy
// aziendali) anche solo leggere `localStorage` solleva un'eccezione: senza
// try/catch il sito restava bianco, perché saveLocale gira a ogni pagina.
export function getSavedLocale(): Locale | null {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved && isValidLocale(saved) ? saved : null;
  } catch {
    return null;
  }
}

export function saveLocale(locale: Locale) {
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    /* archiviazione non disponibile: la lingua resta quella dell'URL */
  }
}

export function detectLocale(): Locale {
  const saved = getSavedLocale();
  if (saved) return saved;

  const browserLangs = navigator.languages || [navigator.language];
  for (const lang of browserLangs) {
    const code = lang.split("-")[0].toLowerCase();
    if (isValidLocale(code)) return code;
  }
  return DEFAULT_LOCALE;
}
